/* Reusable Swipe Handler Utility
 * Adds touch/swipe support to carousel elements
 * Works with any carousel implementation
 */

class SwipeHandler {
  constructor(element, options = {}) {
    this.element = element;
    this.options = {
      threshold: options.threshold || 50, // Minimum distance in pixels to trigger swipe
      restraint: options.restraint || 100, // Maximum vertical distance allowed
      allowedTime: options.allowedTime || 500, // Maximum time allowed to travel distance
      onSwipeLeft: options.onSwipeLeft || null,
      onSwipeRight: options.onSwipeRight || null,
      preventScroll: options.preventScroll || false,
      ...options,
    };

    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchEndX = 0;
    this.touchEndY = 0;
    this.startTime = 0;
    this.isSwiping = false;

    this.init();
  }

  init() {
    this.handleTouchStart = this.onTouchStart.bind(this);
    this.handleTouchMove = this.onTouchMove.bind(this);
    this.handleTouchEnd = this.onTouchEnd.bind(this);

    this.element.addEventListener('touchstart', this.handleTouchStart, { passive: true });
    this.element.addEventListener('touchmove', this.handleTouchMove, { passive: !this.options.preventScroll });
    this.element.addEventListener('touchend', this.handleTouchEnd, { passive: true });
  }

  onTouchStart(e) {
    const touch = e.changedTouches[0];
    this.touchStartX = touch.pageX;
    this.touchStartY = touch.pageY;
    this.startTime = new Date().getTime();
    this.isSwiping = false;
  }

  onTouchMove(e) {
    if (!this.isSwiping) {
      const touch = e.changedTouches[0];
      const deltaX = Math.abs(touch.pageX - this.touchStartX);
      const deltaY = Math.abs(touch.pageY - this.touchStartY);

      // If horizontal movement is greater than vertical, it's a swipe
      if (deltaX > deltaY) {
        this.isSwiping = true;
        if (this.options.preventScroll) {
          e.preventDefault();
        }
      }
    }
  }

  onTouchEnd(e) {
    const touch = e.changedTouches[0];
    this.touchEndX = touch.pageX;
    this.touchEndY = touch.pageY;

    this.handleSwipe();
  }

  handleSwipe() {
    const elapsedTime = new Date().getTime() - this.startTime;

    // Check if swipe meets criteria
    if (elapsedTime <= this.options.allowedTime) {
      const distanceX = this.touchEndX - this.touchStartX;
      const distanceY = Math.abs(this.touchEndY - this.touchStartY);

      // Check if swipe distance is sufficient and vertical movement is minimal
      if (Math.abs(distanceX) >= this.options.threshold && distanceY <= this.options.restraint) {
        if (distanceX < 0) {
          // Swipe left
          if (this.options.onSwipeLeft) {
            this.options.onSwipeLeft();
          }
        } else {
          // Swipe right
          if (this.options.onSwipeRight) {
            this.options.onSwipeRight();
          }
        }
      }
    }

    // Reset
    this.isSwiping = false;
  }

  destroy() {
    this.element.removeEventListener('touchstart', this.handleTouchStart);
    this.element.removeEventListener('touchmove', this.handleTouchMove);
    this.element.removeEventListener('touchend', this.handleTouchEnd);
  }
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = SwipeHandler;
}
